import { PlatformType } from "./types"

export const RESERVATION_PLATFORMS: PlatformType[] = [
  {
    platform: "Hungry Hub",
    reference: "hungryhub",
    keywords: ["hungryhub"],
    website: "https://www.hungryhub.com",
  },
  {
    platform: "QueQ",
    reference: "queq",
    keywords: ["queq"],
    website: "https://www.queq.me",
  },
  {
    platform: "LINE MAN Wongnai",
    reference: "lineman-wongnai",
    keywords: ["wongnai", "lineman"],
    website: "https://www.wongnai.com",
  },
  {
    platform: "Eatable",
    reference: "eatable",
    keywords: ["eatable.co"],
    website: "https://eatable.co",
  },
  {
    platform: "OpenRice",
    reference: "openrice",
    keywords: ["openrice"],
    website: "https://th.openrice.com",
  },
  {
    platform: "GoWabi",
    reference: "gowabi",
    keywords: ["gowabi"],
    website: "https://www.gowabi.com",
  },
  {
    platform: "Klook",
    reference: "klook",
    keywords: ["klook"],
    website: "https://www.klook.com",
  },
  {
    platform: "Eatigo",
    reference: "eatigo",
    keywords: ["eatigo"],
    website: "https://www.eatigo.com",
  },
  {
    platform: "Booking.com",
    reference: "booking",
    keywords: ["booking.com"],
    website: "https://www.booking.com",
  },
  {
    platform: "Agoda",
    reference: "agoda",
    keywords: ["agoda"],
    website: "https://www.agoda.com",
  },
  {
    platform: "Tripadvisor",
    reference: "tripadvisor",
    keywords: ["tripadvisor"],
    website: "https://www.tripadvisor.com",
  },
  {
    platform: "Resy",
    reference: "resy",
    keywords: ["resy"],
    website: "https://www.resy.com",
  },
  {
    platform: "OpenTable",
    reference: "opentable",
    keywords: ["opentable"],
    website: "https://www.opentable.com",
  },
  {
    platform: "TableCheck",
    reference: "tablecheck",
    keywords: ["tablecheck"],
    website: "https://www.tablecheck.com",
  },
  {
    platform: "Chope",
    reference: "chope",
    keywords: ["chope"],
    website: "https://book.chope.co",
  },
  {
    platform: "JPNEASY",
    reference: "jpneasy",
    keywords: ["jpneasy"],
    website: "https://jpneazy.com/",
  },
]

export const SOCIAL_PLATFORMS: PlatformType[] = [
  {
    platform: "Facebook",
    reference: "facebook",
    keywords: ["facebook", "fb.com", "m.me", "messenger.com"],
    website: "https://www.facebook.com",
  },
  {
    platform: "Instagram",
    reference: "instagram",
    keywords: ["instagram", "instagr.am"],
    website: "https://www.instagram.com",
  },
  {
    platform: "LINE",
    reference: "line",
    keywords: ["line.me", "line://"],
    website: "https://line.me",
  },
  {
    platform: "Twitter (X)",
    reference: "twitter-x",
    keywords: ["twitter", "x.com"],
    website: "https://twitter.com",
  },
  {
    platform: "TikTok",
    reference: "tiktok",
    keywords: ["tiktok.com"],
    website: "https://www.tiktok.com",
  },
  {
    platform: "YouTube",
    reference: "youtube",
    keywords: ["youtube", "youtu.be"],
    website: "https://www.youtube.com",
  },
  {
    platform: "Threads",
    reference: "threads",
    keywords: ["threads.net"],
    website: "https://www.threads.net",
  },
]
